import { createSlice } from "@reduxjs/toolkit"



const initialState={
    
    currentSingleSensor:{},
    loading:false,
}

const singleSensorSlice=createSlice({
name:'singleSensor',

initialState,
reducers:{
    loginSuccessSensor:(state,{payload})=>{
        state.loading=false;
        state.currentSingleSensor=payload;
    },
    deleteSensor:(state)=>{
        state.currentSingleSensor={}
    }
}
})
export const {loginSuccessSensor,deleteSensor}=singleSensorSlice.actions
export default singleSensorSlice.reducer